/**
 * Storage abstraction layer.
 * 
 * Currently uses localStorage. To add a backend later, replace the
 * implementations below with API calls — the rest of the app doesn't
 * need to change.
 * 
 * Example backend swap:
 *   get(key)    → fetch(`/api/storage/${key}`)
 *   set(key, v) → fetch(`/api/storage/${key}`, { method: 'PUT', body: v })
 *   remove(key) → fetch(`/api/storage/${key}`, { method: 'DELETE' })
 */

const STORAGE_PREFIX = 'uk-tax-agent:';

const storage = {
  async get(key) {
    try {
      const raw = localStorage.getItem(STORAGE_PREFIX + key);
      if (raw === null) return null;
      return { key, value: raw };
    } catch (e) {
      console.error('Storage get error:', e);
      return null;
    }
  },

  async set(key, value) {
    try {
      localStorage.setItem(STORAGE_PREFIX + key, value);
      return { key, value };
    } catch (e) {
      console.error('Storage set error:', e);
      return null;
    }
  },

  async delete(key) {
    try {
      localStorage.removeItem(STORAGE_PREFIX + key);
      return { key, deleted: true };
    } catch (e) {
      console.error('Storage delete error:', e);
      return null;
    }
  }
};

export default storage;
